import { publicationApi } from 'apiConnector/discover';
import { VideosNoConsent } from 'components/discover/publications/placeholder';
import { SeeMorePublicationsContainer } from 'components/discover/publications/see-more/see-more-publications-container';
import { VideoBrowserSkeleton } from 'components/discover/publications/video-browser/skeleton/video-browser-skeleton';
import { FC, useCallback } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import type { SgBsTheme } from 'state/userPreferences/userPreferences.model';

import { ModalVideoContainer } from '../video/ModalVideoContainer';
import { LoadingSkeleton } from './loading-skeleton';
import { PublicationContainer } from './publication-container';

export const Videos: FC<{ hasGivenConsent?: boolean; enableSeeMore: boolean; theme: SgBsTheme }> = ({
  hasGivenConsent,
  enableSeeMore,
  theme,
}) => {
  const trackOpen = useCallback(() => {
    logAnalytics.trackEvent('Discover', 'Open Video publication');
  }, []);
  const trackSlide = useCallback(() => {
    logAnalytics.trackEvent('Discover', 'Slide Video publication');
  }, []);
  const onSeeMore = useCallback(() => {
    logAnalytics.trackEvent('Discover', 'See more Video publication');
  }, []);

  return (
    <ModalVideoContainer>
      <PublicationContainer
        api={publicationApi.fetchVideos}
        titleKey="discover.videos.title"
        errorKey="discover.videos.error"
        soonKey="discover.videos.soon"
        seeMoreKey="discover.videos.seeMore"
        publishedKey="discover.videos.published"
        id="videos"
        skeleton={<LoadingSkeleton id="videos" hasContent={false} hasPlayButton />}
        noConsent={<VideosNoConsent />}
        hasGivenConsent={hasGivenConsent}
        trackOpen={trackOpen}
        trackSlide={trackSlide}
        onSeeMore={onSeeMore}
        seeMoreModalContent={
          enableSeeMore
            ? onClose => (
                <SeeMorePublicationsContainer
                  theme={theme}
                  onClose={onClose}
                  api={publicationApi.fetchMoreVideos}
                  allKey="discover.videos.all"
                  titleKey="discover.videos.title"
                  skeleton={<VideoBrowserSkeleton />}
                  modalContentType="videos"
                />
              )
            : undefined
        }
      />
    </ModalVideoContainer>
  );
};
